import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, email, regex, digits } from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

import store from './vuex/store'

setInteractionMode('eager');

var locale = document.getElementsByTagName("body")[0].dataset.locale;

if (locale == "en_US") {
  extend('required', {
    ...required,
    message: 'Please fill in the {_field_}'
  });
  
  extend('email', {
    ...email,
    message: 'The E-mail you filled in is incorrect. Please try again.'
  });
  
  extend('digits', {
    ...digits,
    message: 'Please fill in the postal code'
  });
  
  extend('regex', {
    ...regex,
    message: 'Your contact number should contain only numbers and should also consist of ten digits.'
  });

  extend('alphaSymbols', {
    validate: value => {
      const regex = RegExp('^[a-zA-Z\u0370-\u03ff\u1f00-\u1fff!@#$&()\\\-`.+,/\"\s]*$');
      return regex.test(value);
    },
    message: 'The {_field_} should contain only alphabetic characters and symbols.'
  });
  
  extend('validDate', {
    validate: value => {
      var dateformat = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
      if (!value.match(dateformat)) {
        return false;
      }
      var year;
      var date1 = value.split('/');
      var date2 = value.split('-');
      var date3 = value.split('.');
      var len1 = date1.length;
      var len2 = date2.length;

      if (len1 > 1) {
        if (date1[2].length == 2) {
           year = "19" + date1[2];
        } else {
           year = date1[2];
        }
      } else if (len2 > 1) {
        if (date2[2].length == 2) {
           year = "19" + date2[2];
        } else {
           year = date2[2];
        }
      } else {
        if (date3[2].length == 2) {
           year = "19" + date3[2];
        } else {
           year = date3[2];
        }
      }

      if (year < 1901) return false;
      return true;
    },
    message: 'The field Birth Date must be a date.'
  });

  extend('minimumAge', {
    validate: value => {

      var today = new Date();
      var birthDate;
      var dateparts1 = value.split('/');
      var dateparts2 = value.split('-');
      var dateparts3 = value.split('.');
      var length1 = dateparts1.length;
      var length2 = dateparts2.length;
      if (length1 > 1) {
        birthDate = dateparts1[1] + "/" + dateparts1[0] + "/" + dateparts1[2];
      } else if (length2 > 1) {
        birthDate = dateparts2[1] + "-" + dateparts2[0] + "-" + dateparts2[2];
      } else {
        birthDate = dateparts3[1] + "/" + dateparts3[0] + "/" + dateparts3[2];
      }

      var birth = new Date(birthDate);
      var age = today.getFullYear() - birth.getFullYear();
      var m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
          age = age - 1;
      }
      return age >= 18;
    },
    message: 'Minors who do not have an ID card, passport or similar document cannot identify their prepaid mobile phones; their parents/guardians will have to declare their personal details instead. The parents will be the owners of the phone, who will receive and sign the petition, while the minor will be the user'
  });

} else {
  extend('required', {
    ...required,
    message: 'Παρακαλούμε συμπλήρωσε το πεδίο {_field_}'
  });
  
  extend('email', {
    ...email,
    message: 'Το E-mail που συμπλήρωσες δεν είναι σωστό. Παρακαλούμε δοκίμασε ξανά.'
  });
  
  extend('digits', {
    ...digits,
    message: 'Παρακαλούμε εισάγετε έναν έγκυρο Τ.Κ'
  });
  
  extend('regex', {
    ...regex,
    message: 'O αριθμός που συμπλήρωσες δεν είναι σωστός. Παρακαλούμε δοκίμασε ξανά.'
  });

  extend('alphaSymbols', {
    validate: value => {
      const regex = RegExp('^[a-zA-Z\u0370-\u03ff\u1f00-\u1fff!@#$&()\\\-`.+,/\"\s]*$');
      return regex.test(value);
    },
    message: 'Το πεδίο {_field_} πρέπει να περιέχει μόνο αλφαβητικούς χαρακτήρες και σύμβολα.'
  });
  
  extend('validDate', {
    validate: value => {
      var dateformat = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
      if (!value.match(dateformat)) {
        return false;
      }
      var year;
      var date1 = value.split('/');
      var date2 = value.split('-');
      var date3 = value.split('.');
      var len1 = date1.length;
      var len2 = date2.length;

      if (len1 > 1) {
        if (date1[2].length == 2) {
           year = "19" + date1[2];
        } else {
           year = date1[2];
        }
      } else if (len2 > 1) {
        if (date2[2].length == 2) {
           year = "19" + date2[2];
        } else {
           year = date2[2];
        }
      } else {
        if (date3[2].length == 2) {
           year = "19" + date3[2];
        } else {
           year = date3[2];
        }
      }

      if (year < 1901) return false;
      return true;
    },
    message: 'Το πεδίο Ημερομηνία Γέννησης πρέπει να είναι έγκυρη ημερομηνία'
  });

  extend('minimumAge', {
    validate: value => {

      var today = new Date();
      var birthDate;
      var dateparts1 = value.split('/');
      var dateparts2 = value.split('-');
      var dateparts3 = value.split('.');
      var length1 = dateparts1.length;
      var length2 = dateparts2.length;
      if (length1 > 1) {
        birthDate = dateparts1[1] + "/" + dateparts1[0] + "/" + dateparts1[2];
      } else if (length2 > 1) {
        birthDate = dateparts2[1] + "-" + dateparts2[0] + "-" + dateparts2[2];
      } else {
        birthDate = dateparts3[1] + "/" + dateparts3[0] + "/" + dateparts3[2];
      }

      var birth = new Date(birthDate);
      var age = today.getFullYear() - birth.getFullYear();
      var m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
          age = age - 1;
      }
      return age >= 18;
    },
    message: 'Αν δεν έχεις συμπληρώσει το 18ο έτος της ηλικίας σου, θα πρέπει να δηλώσει το καρτοκινητό σου ένας ενήλικας. Αυτός θα θεωρείται ο “παρών κάτοχος/συνδρομητής” του κινητού κι εσύ ο “χρήστης” του.'
  });

}

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
 
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
}).$mount('#join')
